/**
 * Point of Interest pins
 */
export const addPoiPins = ({ google, map, mapData, infowindow }) => {
	const markers = [];
	mapData.poi.forEach((marker) => {
		// normalize input
		const {
			Title: title,
			Latitude: latitude,
			Longitude: longitude,
			Icon: icon,
		} = marker;
		// default to using title as info window's content
		let info = title || '';
		// but if we have content
		if (title) {
			// const content = `<a href="${url}">${title}</a>`;
			const content = `&lt;p&gt;${title}&lt;/p&gt;`;
			// parse the info window content to prevent xss
			const doc = new DOMParser().parseFromString(content, 'text/html');
			// use the info window content
			info = doc.documentElement.textContent;
		}
		// create the pin
		const latLng = new google.maps.LatLng(latitude, longitude);
		const pin = new google.maps.Marker({
			map,
			position: latLng,
			title,
			optimized: false,
			zIndex: 0,
			icon: {
				url: `${mapData.url}/dist/assets/images/pins/pin-${
					icon || 'generic'
				}.svg`,
				scaledSize: new google.maps.Size(25, 25),
			},
		});
		// add this marker for looping over later
		markers.push({ pin });
		// activate the info window when clicking this pin
		const moveToMarker = () => {
			// move to this marker
			map.panTo(pin.position);
			// open the info window with this pin's content
			infowindow.setContent(info);
			infowindow.open({
				anchor: pin,
				map,
			});
		};
		pin.addListener('click', () => moveToMarker());
	});

	// handle map zooming
	google.maps.event.addListener(map, 'zoom_changed', () => {
		const zoom = map.getZoom();
		if (zoom < 6) {
			markers.forEach((marker) => {
				marker.pin.setMap(null);
			});
		} else {
			markers.forEach((marker) => {
				marker.pin.setMap(map);
			});
		}
	});
};
